export default "__VITE_ASSET__DBmkg4lU__"